import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
export default function PaymentSuccess() {
    var params = new URLSearchParams(window.location.search);
    var orderId = params.get("orderId");
    var _a = useState(5), seconds = _a[0], setSeconds = _a[1];
    useEffect(function () {
        var interval = setInterval(function () {
            setSeconds(function (s) {
                if (s <= 1) {
                    clearInterval(interval);
                    window.location.href = "/";
                }
                return s - 1;
            });
        }, 1000);
        return function () { return clearInterval(interval); };
    }, []);
    return (_jsx("div", { className: "status-page", children: _jsx("div", { className: "status-body", children: _jsxs("div", { className: "status-card", children: [_jsx("span", { className: "status-icon", children: "\uD83C\uDF82" }), _jsx("h1", { className: "status-title", children: "Payment Successful" }), orderId && (_jsxs("p", { className: "status-text", style: { marginBottom: "0.5rem" }, children: ["Order #", orderId] })), _jsxs("p", { className: "status-text", children: ["We're confirming your payment and will be in touch soon. Redirecting you home in", " ", _jsx("span", { className: "status-countdown", children: seconds }), "\u2026"] })] }) }) }));
}
